class RecentlyViewedProducts extends HTMLElement {
  static COOKIE_NAME = 'shopify_recently_viewed';
  static MAX_STORED = 10;

  connectedCallback() {
    this.list = this.querySelector('[data-recently-viewed-list]');
    this.cardSection = this.dataset.cardSection || 'recently-viewed';
    this.rootUrl = this.dataset.rootUrl || '/';
    this.limit = parseInt(this.dataset.productsToShow, 10) || 4;

    if (!this.list) return;

    this.recordRecentlyViewed();
    this.loadProducts();
  }

  getCookie(name) {
    if (!document.cookie) return null;

    const cookies = document.cookie.split(';');

    for (const cookie of cookies) {
      const trimmed = cookie.trim();
      const separatorIndex = trimmed.indexOf('=');

      if (separatorIndex === -1) continue;

      const key = trimmed.slice(0, separatorIndex);
      const value = trimmed.slice(separatorIndex + 1);

      if (key === name) {
        return decodeURIComponent(value);
      }
    }

    return null;
  }

  setCookie(name, value, days = 90) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
  }

  readHandles() {
    const cookie = this.getCookie(RecentlyViewedProducts.COOKIE_NAME);
    return cookie ? cookie.split(' ').filter(Boolean) : [];
  }

  writeHandles(handles) {
    this.setCookie(RecentlyViewedProducts.COOKIE_NAME, handles.join(' '));
  }

  getProductHandleFromPath() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : null;
  }

  recordRecentlyViewed() {
    const handle = this.getProductHandleFromPath();
    if (!handle) return;

    let handles = this.readHandles();
    const index = handles.indexOf(handle);

    if (index === -1) {
      handles.unshift(handle);
    } else {
      handles.splice(index, 1);
      handles.unshift(handle);
    }

    handles = handles.slice(0, RecentlyViewedProducts.MAX_STORED);
    this.writeHandles(handles);
  }

  parseSectionHtml(sectionHtml) {
    if (!sectionHtml || !sectionHtml.trim()) return null;

    const template = document.createElement('template');
    template.innerHTML = sectionHtml.trim();
    return template.content.querySelector('[data-recently-viewed-card]:not(.recently-viewed-card--empty)');
  }

  async fetchProductCard(handle) {
    const root = this.rootUrl.endsWith('/') ? this.rootUrl : `${this.rootUrl}/`;
    const sectionsUrl = `${root}products/${encodeURIComponent(handle)}?sections=${this.cardSection}`;
    const sectionUrl = `${root}products/${encodeURIComponent(handle)}?section_id=${this.cardSection}`;

    try {
      const response = await fetch(sectionsUrl);

      if (response.ok) {
        const contentType = response.headers.get('content-type') || '';

        if (contentType.includes('application/json')) {
          const data = await response.json();
          const card = this.parseSectionHtml(data[this.cardSection]);
          if (card) return card;
        }
      }
    } catch (error) {
      console.error('[recently-viewed] sections API failed', error);
    }

    const response = await fetch(sectionUrl);

    if (!response.ok) {
      throw new Error(`Failed to load product card: ${handle}`);
    }

    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    const card = html.querySelector('[data-recently-viewed-card]:not(.recently-viewed-card--empty)');

    if (!card || !card.querySelector('.product-card-wrapper')) {
      return null;
    }

    return card;
  }

  createListItem(card) {
    const item = document.createElement('li');
    item.className = 'grid__item slider__slide';

    while (card.firstChild) {
      item.appendChild(card.firstChild);
    }

    return item;
  }

  hideSection() {
    this.style.display = 'none';
  }

  showSection() {
    this.style.display = '';
  }

  async loadProducts() {
    const handles = this.readHandles().slice(0, this.limit);

    if (!handles.length) {
      this.hideSection();
      return;
    }

    let loadedCount = 0;

    for (const handle of handles) {
      try {
        const card = await this.fetchProductCard(handle);

        if (card) {
          this.list.appendChild(this.createListItem(card));
          loadedCount += 1;
        }
      } catch (error) {
        console.error('[recently-viewed]', error);
      }
    }

    if (loadedCount === 0) {
      this.hideSection();
      return;
    }

    this.showSection();

    if (window.loox && typeof window.loox.init === 'function') {
      window.loox.init();
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
